<div *ngIf="nbDates == 1; else elseBlockDatesPanel">
  <div *ngFor="let logByTypes of logDates.values">
    <app-logger-type [logTypes]="logByTypes"></app-logger-type>
  </div>
</div>
<ng-template #elseBlockDatesPanel>
  <mat-expansion-panel
    *ngIf="logDates?.values?.length > 0; else elseBlockDatesNoData"
    [expanded]="true"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span *ngIf="logDates?.values?.length > 0" class="logdate"
          ><label class="text-secondary">{{ logDates.labelDate }}</label></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div *ngFor="let logByTypes of logDates.values">
      <app-logger-type [logTypes]="logByTypes"></app-logger-type>
    </div>
  </mat-expansion-panel>
  <ng-template #elseBlockDatesNoData>
    <mat-expansion-panel disabled class="no-content">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="logdate"
            ><label class="text-secondary">{{
              logDates.labelDate
            }}</label></span
          >
        </mat-panel-title>
        <mat-panel-description
          ><label class="text-danger">No data</label></mat-panel-description
        >
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  </ng-template>
</ng-template>
